interface AgreementSettingsData {
  lineGroupUrl?: string;
  showQRCode?: boolean;
  qrCodeImageUrl?: string;
  warningText?: string;
  agreementText?: string;
  checkboxLabel?: string;
}

interface Props {
  settings: AgreementSettingsData;
  onChange: (settings: AgreementSettingsData) => void;
}

export default function AgreementSettings({ settings, onChange }: Props) {
  return (
    <div className="space-y-4">
      <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-xs text-blue-700">
          設定報名須知模組的內容，包含 LINE 群組資訊與同意條款
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">LINE 群組連結</label>
        <input
          type="url"
          value={settings.lineGroupUrl || ''}
          onChange={(e) => onChange({ ...settings, lineGroupUrl: e.target.value })}
          placeholder="https://line.me/ti/g/..."
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
        />
        <p className="text-xs text-gray-500 mt-1">用戶點擊「加入群組」時會開啟此連結</p>
      </div>

      <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
        <div>
          <span className="text-sm font-medium">顯示 QR Code</span>
          <p className="text-xs text-gray-500 mt-0.5">在報名須知頁面顯示群組 QR Code</p>
        </div>
        <button
          onClick={() => onChange({ ...settings, showQRCode: !settings.showQRCode })}
          className={`w-10 h-5 rounded-full transition-colors relative ${
            settings.showQRCode ? 'bg-primary' : 'bg-gray-300'
          }`}
        >
          <span className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform ${
            settings.showQRCode ? 'left-5' : 'left-0.5'
          }`} />
        </button>
      </div>

      {settings.showQRCode && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">QR Code 圖片網址 (建議 300x300)</label>
          <input
            type="url"
            value={settings.qrCodeImageUrl || ''}
            onChange={(e) => onChange({ ...settings, qrCodeImageUrl: e.target.value })}
            placeholder="https://example.com/qrcode.png"
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
          />
          <p className="text-xs text-gray-500 mt-1">留空時將自動從 LINE 群組連結生成</p>

          {/* QR Preview */}
          {(settings.qrCodeImageUrl || settings.lineGroupUrl) && (
            <div className="mt-2 flex justify-center">
              <img
                src={settings.qrCodeImageUrl || `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(settings.lineGroupUrl || '')}`}
                alt="QR Code Preview"
                className="w-24 h-24 border border-gray-200 rounded-lg"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
            </div>
          )}
        </div>
      )}

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">警告文字</label>
        <textarea
          value={settings.warningText || ''}
          onChange={(e) => onChange({ ...settings, warningText: e.target.value })}
          placeholder="例: 請務必加入 LINE 群組以接收重要通知"
          rows={2}
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
        />
        <p className="text-xs text-gray-500 mt-1">會以醒目方式顯示在報名須知中</p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">同意條款內容</label>
        <textarea
          value={settings.agreementText || ''}
          onChange={(e) => onChange({ ...settings, agreementText: e.target.value })}
          placeholder="例: 我已詳閱並同意以上報名須知..."
          rows={3}
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">勾選框標籤</label>
        <input
          type="text"
          value={settings.checkboxLabel || ''}
          onChange={(e) => onChange({ ...settings, checkboxLabel: e.target.value })}
          placeholder="例: 我同意以上條款"
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
        />
      </div>
    </div>
  );
}
